<template>
  <div class="d-timetal__container marg-1-top">
    <h4 class="uppercase marg-1-bottom">Fag</h4>
    <h3 v-if="personaleUdenKorrekteOplysninger.length === 0 && fagUdenKorrekteOplysninger.length === 0">Alt er udfyldt
      korrekt</h3>
    <div class="d-attention"
         v-if="personaleUdenKorrekteOplysninger.length > 0 || fagUdenKorrekteOplysninger.length > 0">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="tw-icon icon-important">
        <path class="primary" d="M12 2a10 10 0 1 1 0 20 10 10 0 0 1 0-20z"/>
        <path class="secondary"
              d="M12 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm1-5.9c-.13 1.2-1.88 1.2-2 0l-.5-5a1 1 0 0 1 1-1.1h1a1 1 0 0 1 1 1.1l-.5 5z"/>
      </svg>
      <h3>Følgende fag mangler oplysninger</h3>
      <p>Gå til step 3. "Fag" og tilføj oplysningerne eller slet faget, hvis faget ikke skal indberettes.</p>
      <table class="d-table d-table__borders">
        <thead>
        <th>Fag</th>
        <th>Fejl</th>
        </thead>
        <tbody>
        <tr v-for="(fag, key) in fagUdenKorrekteOplysninger" :key="fag.fag_id">
          <td>{{ fag.klasse }}, {{ fag.fag_navn }}</td>
          <td><span class="fag-errors" v-for="(error, errorIdx) in fag.errors">{{ error }}<template
            v-if="errorIdx + 1 < fag.errors.length">, </template></span></td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    stilData: {
      type: Object,
      default: () => {
      }
    }
  },
  data () {
    return {
      stillinger: {
        LA: 'Lærere',
        BH: 'Børnehaveklasseledere',
        PA: 'Pædagoger',
        LE: 'Ledere',
        AN: 'Andre med undervisningsopgaver',
        KO: 'Konsulenter'
      }
    }
  },
  computed: {
    allUsersInHash () {
      return this.$store.getters.allUsersInHash
    },
    klasser () {
      const klasser = this.stilData['klasser'] ? this.stilData['klasser'] : []
      return klasser.sort((a, b) => {
        return a.klassebetegnelse.localeCompare(b.klassebetegnelse, 'da', {
          numeric: true,
          sensitivity: 'base'
        })
      })
    },
    fag () {
      const fagArr = []
      this.klasser.forEach(klasse => {
        klasse.fag.forEach(fag => {
          const obj = {
            klasse: klasse.klassebetegnelse,
            klassetrin: klasse.klassetrin,
            ...fag
          }
          fagArr.push(obj)
        })
      })
      return fagArr
    },
    fagUdenKorrekteOplysninger () {
      const fagMedManglendeOplysninger = []

      this.fag.forEach(fag => {
        const klassename = fag.klasse ? fag.klasse : 'Klassen'
        let errors = []

        // Tjek for manglende oplysninger
        if (!fag.klasse) {
          errors.push(klassename + ' mangler klassebetegnelse')
        }
        if (!fag.klassetrin) {
          errors.push(klassename + ' mangler klassetrin')
        }
        if (!fag.fagkode || String(fag.fagkode).trim() === '') {
          errors.push('Fag mangler fagkode')
        }
        if (!fag.klokketimer) {
          errors.push('Fag mangler klokketimer')
        } else {
          const klokketimerNum = Number(fag.klokketimer) // Konverterer til tal uden at ændre typen
          if (isNaN(klokketimerNum)) {
            errors.push('Klokketimer skal være et tal')
          } else if (!Number.isInteger(klokketimerNum)) {
            errors.push('Klokketimer skal være et helt tal')
          }
        }

// Tjek for lærere
        if (!Array.isArray(fag.laerere) || fag.laerere.length === 0) {
          errors.push('Fag mangler lærer')
        } else {
          fag.laerere.forEach(laerer => {
            const username = laerer.user_name ? laerer.user_name : 'En lærer'

            if (!laerer.cpr) {
              errors.push(username + ' mangler cpr')
            }

            if (!laerer.klokketimer) {
              errors.push(username + ' mangler klokketimer')
            } else {
              const laererKlokketimerNum = Number(laerer.klokketimer) // Konverter til tal for validering
              if (isNaN(laererKlokketimerNum)) {
                errors.push(username + 's klokketimer skal være et tal')
              } else if (!Number.isInteger(laererKlokketimerNum)) {
                errors.push(username + 's klokketimer skal være et helt tal')
              }
            }
          })
        }

        // Tilføj faget til listen, hvis der er fejl
        if (errors.length > 0) {
          const newFag = {
            ...fag,
            errors
          }
          fagMedManglendeOplysninger.push(newFag)
        }
      })

      return fagMedManglendeOplysninger
    },
    laerere () {
      return this.stilData['laerere'] ? this.stilData['laerere'] : []
    },
    personaleUdenKorrekteOplysninger () {
      const users = this.laerere.filter(laerer => laerer.stilling !== 'undtaget' && (!laerer.cpr || !laerer.stilling))
      const usersWithProps = users.map(user => {
        const name = this.allUsersInHash[user.user_id] ? this.allUsersInHash[user.user_id].name : user.user_id
        return {
          ...user,
          name
        }
      })
      return this.$helpers.sortArrOnName(usersWithProps)
    }
  }
}
</script>

<style scoped>
.d-table {
  width: 100%;
  border: 1px solid #d8d8d8;
  border-collapse: collapse;
  border-radius: 4px;
}

.d-table.d-table__subjects tbody tr.tr--one {
  border-bottom: 1px solid #d8d8d8;
  background: #f6f9fc;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
  font-weight: bold;
}

.d-table tbody tr.tr__header {
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  color: #728195;
}

.d-table tbody tr:not(.tr__header):hover {
  background: aliceblue !important;
}

.d-table thead {
  border: 1px solid #d8d8d8;
  background: #f6f9fc;
  color: #728195;
  text-transform: uppercase;
  border-radius: 4px;
  font-size: 11px;
}

.d-table thead th {
  padding: 0.5rem 1rem;
  text-align: left;
  color: #222;
}

.d-table tbody tr {
  background: #ffffff;
  width: 100%;
  border-bottom: 1px solid #e3e8ee;
}

.d-table tbody tr td:first-child {
  padding-left: 2rem;
}

.d-table tbody tr.tr__header td:first-child {
  padding-left: 2rem;
}

.d-table tbody tr:nth-child(even) {
  background: #fbfbfb;
}

.d-table tbody tr td {
  padding: 0.25rem 1rem;
  text-align: left;
}

.d-timetal__container {
  padding: 2rem 1rem;
  border: 1px solid #d8d8d8;
  width: 100%;
  max-width: 1440px;
  min-width: 1100px;
  border-radius: 4px;
}

.d-table.d-table__borders {
  width: auto;
}

.d-table.d-table__borders tbody tr td,
.d-table.d-table__borders thead tr th {
  border-left: 1px solid #cccccc;
}

</style>

</template>



// WEBPACK FOOTER //
// IndberetFag.vue?62c2b3d3